// source: io/codedrills/proto/content/scoring.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var io_codedrills_proto_content_preview_pb = require('../../../../io/codedrills/proto/content/preview_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_preview_pb);
goog.exportSymbol('proto.io.codedrills.proto.content.ProblemScore', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Scoreboard', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ScoreboardAccessType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ScoreboardConfig', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ScoreboardSnapshot', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ScoreboardStats', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ScoreboardStatus', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ScoringStatus', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.TeamScore', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.UserProblemScore', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.UserScore', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.Scoreboard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.Scoreboard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.Scoreboard.displayName = 'proto.io.codedrills.proto.content.Scoreboard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.ScoreboardSnapshot.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.ScoreboardSnapshot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ScoreboardSnapshot.displayName = 'proto.io.codedrills.proto.content.ScoreboardSnapshot';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ScoreboardStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.ScoreboardStats.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.ScoreboardStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ScoreboardStats.displayName = 'proto.io.codedrills.proto.content.ScoreboardStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ScoreboardConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.ScoreboardConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ScoreboardConfig.displayName = 'proto.io.codedrills.proto.content.ScoreboardConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.UserScore = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.UserScore.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.UserScore, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.UserScore.displayName = 'proto.io.codedrills.proto.content.UserScore';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.TeamScore = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.TeamScore.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.TeamScore, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.TeamScore.displayName = 'proto.io.codedrills.proto.content.TeamScore';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.UserProblemScore = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.UserProblemScore, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.UserProblemScore.displayName = 'proto.io.codedrills.proto.content.UserProblemScore';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ProblemScore = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.ProblemScore, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ProblemScore.displayName = 'proto.io.codedrills.proto.content.ProblemScore';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.Scoreboard.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.Scoreboard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.Scoreboard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Scoreboard.toObject = function(includeInstance, msg) {
  var f, obj = {
    contestId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 2, 0),
    lastSubmissionId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    scoreboardStatus: jspb.Message.getFieldWithDefault(msg, 4, 0),
    scoreboardSnapshotsMap: (f = msg.getScoreboardSnapshotsMap()) ? f.toObject(includeInstance, proto.io.codedrills.proto.content.ScoreboardSnapshot.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.Scoreboard}
 */
proto.io.codedrills.proto.content.Scoreboard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.Scoreboard;
  return proto.io.codedrills.proto.content.Scoreboard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.Scoreboard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.Scoreboard}
 */
proto.io.codedrills.proto.content.Scoreboard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContestId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLastSubmissionId(value);
      break;
    case 4:
      var value = /** @type {!proto.io.codedrills.proto.content.ScoreboardStatus} */ (reader.readEnum());
      msg.setScoreboardStatus(value);
      break;
    case 5:
      var value = msg.getScoreboardSnapshotsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.io.codedrills.proto.content.ScoreboardSnapshot.deserializeBinaryFromReader, "", new proto.io.codedrills.proto.content.ScoreboardSnapshot());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.Scoreboard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.Scoreboard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.Scoreboard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Scoreboard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContestId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getLastSubmissionId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getScoreboardStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getScoreboardSnapshotsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.io.codedrills.proto.content.ScoreboardSnapshot.serializeBinaryToWriter);
  }
};


/**
 * optional int32 contest_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.Scoreboard.prototype.getContestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Scoreboard} returns this
 */
proto.io.codedrills.proto.content.Scoreboard.prototype.setContestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 updated_at = 2;
 * @return {number}
 */
proto.io.codedrills.proto.content.Scoreboard.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Scoreboard} returns this
 */
proto.io.codedrills.proto.content.Scoreboard.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 last_submission_id = 3;
 * @return {number}
 */
proto.io.codedrills.proto.content.Scoreboard.prototype.getLastSubmissionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Scoreboard} returns this
 */
proto.io.codedrills.proto.content.Scoreboard.prototype.setLastSubmissionId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional ScoreboardStatus scoreboard_status = 4;
 * @return {!proto.io.codedrills.proto.content.ScoreboardStatus}
 */
proto.io.codedrills.proto.content.Scoreboard.prototype.getScoreboardStatus = function() {
  return /** @type {!proto.io.codedrills.proto.content.ScoreboardStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ScoreboardStatus} value
 * @return {!proto.io.codedrills.proto.content.Scoreboard} returns this
 */
proto.io.codedrills.proto.content.Scoreboard.prototype.setScoreboardStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * map<string, ScoreboardSnapshot> scoreboard_snapshots = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.io.codedrills.proto.content.ScoreboardSnapshot>}
 */
proto.io.codedrills.proto.content.Scoreboard.prototype.getScoreboardSnapshotsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.io.codedrills.proto.content.ScoreboardSnapshot>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.io.codedrills.proto.content.ScoreboardSnapshot));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.io.codedrills.proto.content.Scoreboard} returns this
 */
proto.io.codedrills.proto.content.Scoreboard.prototype.clearScoreboardSnapshotsMap = function() {
  this.getScoreboardSnapshotsMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ScoreboardSnapshot.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ScoreboardSnapshot} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.toObject = function(includeInstance, msg) {
  var f, obj = {
    scoreboardStats: (f = msg.getScoreboardStats()) && proto.io.codedrills.proto.content.ScoreboardStats.toObject(includeInstance, f),
    userScoresList: jspb.Message.toObjectList(msg.getUserScoresList(),
    proto.io.codedrills.proto.content.UserScore.toObject, includeInstance),
    contestPreview: (f = msg.getContestPreview()) && io_codedrills_proto_content_preview_pb.ContentPreview.toObject(includeInstance, f),
    scoreboardAccessType: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ScoreboardSnapshot}
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ScoreboardSnapshot;
  return proto.io.codedrills.proto.content.ScoreboardSnapshot.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ScoreboardSnapshot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ScoreboardSnapshot}
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.content.ScoreboardStats;
      reader.readMessage(value,proto.io.codedrills.proto.content.ScoreboardStats.deserializeBinaryFromReader);
      msg.setScoreboardStats(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.content.UserScore;
      reader.readMessage(value,proto.io.codedrills.proto.content.UserScore.deserializeBinaryFromReader);
      msg.addUserScores(value);
      break;
    case 3:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.setContestPreview(value);
      break;
    case 4:
      var value = /** @type {!proto.io.codedrills.proto.content.ScoreboardAccessType} */ (reader.readEnum());
      msg.setScoreboardAccessType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ScoreboardSnapshot.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ScoreboardSnapshot} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScoreboardStats();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.content.ScoreboardStats.serializeBinaryToWriter
    );
  }
  f = message.getUserScoresList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.io.codedrills.proto.content.UserScore.serializeBinaryToWriter
    );
  }
  f = message.getContestPreview();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
  f = message.getScoreboardAccessType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional ScoreboardStats scoreboard_stats = 1;
 * @return {?proto.io.codedrills.proto.content.ScoreboardStats}
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.getScoreboardStats = function() {
  return /** @type{?proto.io.codedrills.proto.content.ScoreboardStats} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.ScoreboardStats, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ScoreboardStats|undefined} value
 * @return {!proto.io.codedrills.proto.content.ScoreboardSnapshot} returns this
*/
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.setScoreboardStats = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.ScoreboardSnapshot} returns this
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.clearScoreboardStats = function() {
  return this.setScoreboardStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.hasScoreboardStats = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated UserScore user_scores = 2;
 * @return {!Array<!proto.io.codedrills.proto.content.UserScore>}
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.getUserScoresList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.UserScore>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.UserScore, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.UserScore>} value
 * @return {!proto.io.codedrills.proto.content.ScoreboardSnapshot} returns this
*/
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.setUserScoresList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.UserScore=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.UserScore}
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.addUserScores = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.content.UserScore, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.ScoreboardSnapshot} returns this
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.clearUserScoresList = function() {
  return this.setUserScoresList([]);
};


/**
 * optional ContentPreview contest_preview = 3;
 * @return {?proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.getContestPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.content.ScoreboardSnapshot} returns this
*/
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.setContestPreview = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.ScoreboardSnapshot} returns this
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.clearContestPreview = function() {
  return this.setContestPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.hasContestPreview = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ScoreboardAccessType scoreboard_access_type = 4;
 * @return {!proto.io.codedrills.proto.content.ScoreboardAccessType}
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.getScoreboardAccessType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ScoreboardAccessType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ScoreboardAccessType} value
 * @return {!proto.io.codedrills.proto.content.ScoreboardSnapshot} returns this
 */
proto.io.codedrills.proto.content.ScoreboardSnapshot.prototype.setScoreboardAccessType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.ScoreboardStats.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ScoreboardStats.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ScoreboardStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ScoreboardStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ScoreboardStats.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemScoresList: jspb.Message.toObjectList(msg.getProblemScoresList(),
    proto.io.codedrills.proto.content.ProblemScore.toObject, includeInstance),
    totalParticipants: jspb.Message.getFieldWithDefault(msg, 2, 0),
    totalSubmissions: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ScoreboardStats}
 */
proto.io.codedrills.proto.content.ScoreboardStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ScoreboardStats;
  return proto.io.codedrills.proto.content.ScoreboardStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ScoreboardStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ScoreboardStats}
 */
proto.io.codedrills.proto.content.ScoreboardStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.content.ProblemScore;
      reader.readMessage(value,proto.io.codedrills.proto.content.ProblemScore.deserializeBinaryFromReader);
      msg.addProblemScores(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalParticipants(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalSubmissions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ScoreboardStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ScoreboardStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ScoreboardStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ScoreboardStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemScoresList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.io.codedrills.proto.content.ProblemScore.serializeBinaryToWriter
    );
  }
  f = message.getTotalParticipants();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotalSubmissions();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated ProblemScore problem_scores = 1;
 * @return {!Array<!proto.io.codedrills.proto.content.ProblemScore>}
 */
proto.io.codedrills.proto.content.ScoreboardStats.prototype.getProblemScoresList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.ProblemScore>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.ProblemScore, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.ProblemScore>} value
 * @return {!proto.io.codedrills.proto.content.ScoreboardStats} returns this
*/
proto.io.codedrills.proto.content.ScoreboardStats.prototype.setProblemScoresList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.ProblemScore=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ProblemScore}
 */
proto.io.codedrills.proto.content.ScoreboardStats.prototype.addProblemScores = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.content.ProblemScore, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.ScoreboardStats} returns this
 */
proto.io.codedrills.proto.content.ScoreboardStats.prototype.clearProblemScoresList = function() {
  return this.setProblemScoresList([]);
};


/**
 * optional int32 total_participants = 2;
 * @return {number}
 */
proto.io.codedrills.proto.content.ScoreboardStats.prototype.getTotalParticipants = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ScoreboardStats} returns this
 */
proto.io.codedrills.proto.content.ScoreboardStats.prototype.setTotalParticipants = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 total_submissions = 3;
 * @return {number}
 */
proto.io.codedrills.proto.content.ScoreboardStats.prototype.getTotalSubmissions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ScoreboardStats} returns this
 */
proto.io.codedrills.proto.content.ScoreboardStats.prototype.setTotalSubmissions = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ScoreboardConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ScoreboardConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ScoreboardConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ScoreboardConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    scoreTillSec: jspb.Message.getFieldWithDefault(msg, 1, 0),
    scoreboardAccessType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ScoreboardConfig}
 */
proto.io.codedrills.proto.content.ScoreboardConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ScoreboardConfig;
  return proto.io.codedrills.proto.content.ScoreboardConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ScoreboardConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ScoreboardConfig}
 */
proto.io.codedrills.proto.content.ScoreboardConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setScoreTillSec(value);
      break;
    case 2:
      var value = /** @type {!proto.io.codedrills.proto.content.ScoreboardAccessType} */ (reader.readEnum());
      msg.setScoreboardAccessType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ScoreboardConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ScoreboardConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ScoreboardConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ScoreboardConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScoreTillSec();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getScoreboardAccessType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional int64 score_till_sec = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.ScoreboardConfig.prototype.getScoreTillSec = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ScoreboardConfig} returns this
 */
proto.io.codedrills.proto.content.ScoreboardConfig.prototype.setScoreTillSec = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ScoreboardAccessType scoreboard_access_type = 2;
 * @return {!proto.io.codedrills.proto.content.ScoreboardAccessType}
 */
proto.io.codedrills.proto.content.ScoreboardConfig.prototype.getScoreboardAccessType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ScoreboardAccessType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ScoreboardAccessType} value
 * @return {!proto.io.codedrills.proto.content.ScoreboardConfig} returns this
 */
proto.io.codedrills.proto.content.ScoreboardConfig.prototype.setScoreboardAccessType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.UserScore.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.UserScore.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.UserScore.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.UserScore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.UserScore.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userPreview: (f = msg.getUserPreview()) && io_codedrills_proto_content_preview_pb.UserPreview.toObject(includeInstance, f),
    rank: jspb.Message.getFieldWithDefault(msg, 3, 0),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    penalty: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    userProblemScoresList: jspb.Message.toObjectList(msg.getUserProblemScoresList(),
    proto.io.codedrills.proto.content.UserProblemScore.toObject, includeInstance),
    teamId: jspb.Message.getFieldWithDefault(msg, 7, 0),
    teamPreview: (f = msg.getTeamPreview()) && io_codedrills_proto_content_preview_pb.TeamPreview.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.UserScore}
 */
proto.io.codedrills.proto.content.UserScore.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.UserScore;
  return proto.io.codedrills.proto.content.UserScore.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.UserScore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.UserScore}
 */
proto.io.codedrills.proto.content.UserScore.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_preview_pb.UserPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.UserPreview.deserializeBinaryFromReader);
      msg.setUserPreview(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPenalty(value);
      break;
    case 6:
      var value = new proto.io.codedrills.proto.content.UserProblemScore;
      reader.readMessage(value,proto.io.codedrills.proto.content.UserProblemScore.deserializeBinaryFromReader);
      msg.addUserProblemScores(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTeamId(value);
      break;
    case 8:
      var value = new io_codedrills_proto_content_preview_pb.TeamPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.TeamPreview.deserializeBinaryFromReader);
      msg.setTeamPreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.UserScore.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.UserScore.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.UserScore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.UserScore.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserPreview();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_preview_pb.UserPreview.serializeBinaryToWriter
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getPenalty();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getUserProblemScoresList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.io.codedrills.proto.content.UserProblemScore.serializeBinaryToWriter
    );
  }
  f = message.getTeamId();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getTeamPreview();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      io_codedrills_proto_content_preview_pb.TeamPreview.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.UserScore.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.UserScore} returns this
 */
proto.io.codedrills.proto.content.UserScore.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional UserPreview user_preview = 2;
 * @return {?proto.io.codedrills.proto.content.UserPreview}
 */
proto.io.codedrills.proto.content.UserScore.prototype.getUserPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.UserPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.UserPreview, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.UserPreview|undefined} value
 * @return {!proto.io.codedrills.proto.content.UserScore} returns this
*/
proto.io.codedrills.proto.content.UserScore.prototype.setUserPreview = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.UserScore} returns this
 */
proto.io.codedrills.proto.content.UserScore.prototype.clearUserPreview = function() {
  return this.setUserPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.UserScore.prototype.hasUserPreview = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 rank = 3;
 * @return {number}
 */
proto.io.codedrills.proto.content.UserScore.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.UserScore} returns this
 */
proto.io.codedrills.proto.content.UserScore.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double score = 4;
 * @return {number}
 */
proto.io.codedrills.proto.content.UserScore.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.UserScore} returns this
 */
proto.io.codedrills.proto.content.UserScore.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double penalty = 5;
 * @return {number}
 */
proto.io.codedrills.proto.content.UserScore.prototype.getPenalty = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.UserScore} returns this
 */
proto.io.codedrills.proto.content.UserScore.prototype.setPenalty = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * repeated UserProblemScore user_problem_scores = 6;
 * @return {!Array<!proto.io.codedrills.proto.content.UserProblemScore>}
 */
proto.io.codedrills.proto.content.UserScore.prototype.getUserProblemScoresList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.UserProblemScore>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.UserProblemScore, 6));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.UserProblemScore>} value
 * @return {!proto.io.codedrills.proto.content.UserScore} returns this
*/
proto.io.codedrills.proto.content.UserScore.prototype.setUserProblemScoresList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.UserProblemScore=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.UserProblemScore}
 */
proto.io.codedrills.proto.content.UserScore.prototype.addUserProblemScores = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.io.codedrills.proto.content.UserProblemScore, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.UserScore} returns this
 */
proto.io.codedrills.proto.content.UserScore.prototype.clearUserProblemScoresList = function() {
  return this.setUserProblemScoresList([]);
};


/**
 * optional int32 team_id = 7;
 * @return {number}
 */
proto.io.codedrills.proto.content.UserScore.prototype.getTeamId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.UserScore} returns this
 */
proto.io.codedrills.proto.content.UserScore.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional TeamPreview team_preview = 8;
 * @return {?proto.io.codedrills.proto.content.TeamPreview}
 */
proto.io.codedrills.proto.content.UserScore.prototype.getTeamPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.TeamPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.TeamPreview, 8));
};


/**
 * @param {?proto.io.codedrills.proto.content.TeamPreview|undefined} value
 * @return {!proto.io.codedrills.proto.content.UserScore} returns this
*/
proto.io.codedrills.proto.content.UserScore.prototype.setTeamPreview = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.UserScore} returns this
 */
proto.io.codedrills.proto.content.UserScore.prototype.clearTeamPreview = function() {
  return this.setTeamPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.UserScore.prototype.hasTeamPreview = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.TeamScore.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.TeamScore.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.TeamScore.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.TeamScore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.TeamScore.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    teamPreview: (f = msg.getTeamPreview()) && io_codedrills_proto_content_preview_pb.TeamPreview.toObject(includeInstance, f),
    rank: jspb.Message.getFieldWithDefault(msg, 3, 0),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    penalty: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    userProblemScoresList: jspb.Message.toObjectList(msg.getUserProblemScoresList(),
    proto.io.codedrills.proto.content.UserProblemScore.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.TeamScore}
 */
proto.io.codedrills.proto.content.TeamScore.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.TeamScore;
  return proto.io.codedrills.proto.content.TeamScore.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.TeamScore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.TeamScore}
 */
proto.io.codedrills.proto.content.TeamScore.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTeamId(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_preview_pb.TeamPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.TeamPreview.deserializeBinaryFromReader);
      msg.setTeamPreview(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRank(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPenalty(value);
      break;
    case 6:
      var value = new proto.io.codedrills.proto.content.UserProblemScore;
      reader.readMessage(value,proto.io.codedrills.proto.content.UserProblemScore.deserializeBinaryFromReader);
      msg.addUserProblemScores(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.TeamScore.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.TeamScore.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.TeamScore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.TeamScore.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTeamPreview();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_preview_pb.TeamPreview.serializeBinaryToWriter
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getPenalty();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getUserProblemScoresList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.io.codedrills.proto.content.UserProblemScore.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 team_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.TeamScore.prototype.getTeamId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.TeamScore} returns this
 */
proto.io.codedrills.proto.content.TeamScore.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional TeamPreview team_preview = 2;
 * @return {?proto.io.codedrills.proto.content.TeamPreview}
 */
proto.io.codedrills.proto.content.TeamScore.prototype.getTeamPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.TeamPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.TeamPreview, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.TeamPreview|undefined} value
 * @return {!proto.io.codedrills.proto.content.TeamScore} returns this
*/
proto.io.codedrills.proto.content.TeamScore.prototype.setTeamPreview = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.TeamScore} returns this
 */
proto.io.codedrills.proto.content.TeamScore.prototype.clearTeamPreview = function() {
  return this.setTeamPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.TeamScore.prototype.hasTeamPreview = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 rank = 3;
 * @return {number}
 */
proto.io.codedrills.proto.content.TeamScore.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.TeamScore} returns this
 */
proto.io.codedrills.proto.content.TeamScore.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double score = 4;
 * @return {number}
 */
proto.io.codedrills.proto.content.TeamScore.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.TeamScore} returns this
 */
proto.io.codedrills.proto.content.TeamScore.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double penalty = 5;
 * @return {number}
 */
proto.io.codedrills.proto.content.TeamScore.prototype.getPenalty = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.TeamScore} returns this
 */
proto.io.codedrills.proto.content.TeamScore.prototype.setPenalty = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * repeated UserProblemScore user_problem_scores = 6;
 * @return {!Array<!proto.io.codedrills.proto.content.UserProblemScore>}
 */
proto.io.codedrills.proto.content.TeamScore.prototype.getUserProblemScoresList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.UserProblemScore>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.UserProblemScore, 6));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.UserProblemScore>} value
 * @return {!proto.io.codedrills.proto.content.TeamScore} returns this
*/
proto.io.codedrills.proto.content.TeamScore.prototype.setUserProblemScoresList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.UserProblemScore=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.UserProblemScore}
 */
proto.io.codedrills.proto.content.TeamScore.prototype.addUserProblemScores = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.io.codedrills.proto.content.UserProblemScore, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.TeamScore} returns this
 */
proto.io.codedrills.proto.content.TeamScore.prototype.clearUserProblemScoresList = function() {
  return this.setUserProblemScoresList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.UserProblemScore.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.UserProblemScore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.UserProblemScore.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    totalSubmissions: jspb.Message.getFieldWithDefault(msg, 2, 0),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    penalty: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    solvedAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
    successfulSubmissionPreview: (f = msg.getSuccessfulSubmissionPreview()) && io_codedrills_proto_content_preview_pb.SubmissionPreview.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.UserProblemScore}
 */
proto.io.codedrills.proto.content.UserProblemScore.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.UserProblemScore;
  return proto.io.codedrills.proto.content.UserProblemScore.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.UserProblemScore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.UserProblemScore}
 */
proto.io.codedrills.proto.content.UserProblemScore.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalSubmissions(value);
      break;
    case 3:
      var value = /** @type {!proto.io.codedrills.proto.content.ScoringStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPenalty(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSolvedAt(value);
      break;
    case 7:
      var value = new io_codedrills_proto_content_preview_pb.SubmissionPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.SubmissionPreview.deserializeBinaryFromReader);
      msg.setSuccessfulSubmissionPreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.UserProblemScore.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.UserProblemScore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.UserProblemScore.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalSubmissions();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getPenalty();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getSolvedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getSuccessfulSubmissionPreview();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      io_codedrills_proto_content_preview_pb.SubmissionPreview.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 problem_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.getProblemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.UserProblemScore} returns this
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.setProblemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 total_submissions = 2;
 * @return {number}
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.getTotalSubmissions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.UserProblemScore} returns this
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.setTotalSubmissions = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional ScoringStatus status = 3;
 * @return {!proto.io.codedrills.proto.content.ScoringStatus}
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.getStatus = function() {
  return /** @type {!proto.io.codedrills.proto.content.ScoringStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ScoringStatus} value
 * @return {!proto.io.codedrills.proto.content.UserProblemScore} returns this
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional double score = 4;
 * @return {number}
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.UserProblemScore} returns this
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double penalty = 5;
 * @return {number}
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.getPenalty = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.UserProblemScore} returns this
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.setPenalty = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int64 solved_at = 6;
 * @return {number}
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.getSolvedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.UserProblemScore} returns this
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.setSolvedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional SubmissionPreview successful_submission_preview = 7;
 * @return {?proto.io.codedrills.proto.content.SubmissionPreview}
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.getSuccessfulSubmissionPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.SubmissionPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.SubmissionPreview, 7));
};


/**
 * @param {?proto.io.codedrills.proto.content.SubmissionPreview|undefined} value
 * @return {!proto.io.codedrills.proto.content.UserProblemScore} returns this
*/
proto.io.codedrills.proto.content.UserProblemScore.prototype.setSuccessfulSubmissionPreview = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.UserProblemScore} returns this
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.clearSuccessfulSubmissionPreview = function() {
  return this.setSuccessfulSubmissionPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.UserProblemScore.prototype.hasSuccessfulSubmissionPreview = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ProblemScore.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ProblemScore.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ProblemScore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ProblemScore.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    totalSubmissions: jspb.Message.getFieldWithDefault(msg, 2, 0),
    solvedUserCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    problemPreview: (f = msg.getProblemPreview()) && io_codedrills_proto_content_preview_pb.ContentPreview.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ProblemScore}
 */
proto.io.codedrills.proto.content.ProblemScore.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ProblemScore;
  return proto.io.codedrills.proto.content.ProblemScore.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ProblemScore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ProblemScore}
 */
proto.io.codedrills.proto.content.ProblemScore.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalSubmissions(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSolvedUserCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    case 5:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.setProblemPreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ProblemScore.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ProblemScore.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ProblemScore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ProblemScore.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalSubmissions();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSolvedUserCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getProblemPreview();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 problem_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.ProblemScore.prototype.getProblemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ProblemScore} returns this
 */
proto.io.codedrills.proto.content.ProblemScore.prototype.setProblemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 total_submissions = 2;
 * @return {number}
 */
proto.io.codedrills.proto.content.ProblemScore.prototype.getTotalSubmissions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ProblemScore} returns this
 */
proto.io.codedrills.proto.content.ProblemScore.prototype.setTotalSubmissions = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 solved_user_count = 3;
 * @return {number}
 */
proto.io.codedrills.proto.content.ProblemScore.prototype.getSolvedUserCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ProblemScore} returns this
 */
proto.io.codedrills.proto.content.ProblemScore.prototype.setSolvedUserCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double score = 4;
 * @return {number}
 */
proto.io.codedrills.proto.content.ProblemScore.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ProblemScore} returns this
 */
proto.io.codedrills.proto.content.ProblemScore.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional ContentPreview problem_preview = 5;
 * @return {?proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.content.ProblemScore.prototype.getProblemPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 5));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.content.ProblemScore} returns this
*/
proto.io.codedrills.proto.content.ProblemScore.prototype.setProblemPreview = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.ProblemScore} returns this
 */
proto.io.codedrills.proto.content.ProblemScore.prototype.clearProblemPreview = function() {
  return this.setProblemPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.ProblemScore.prototype.hasProblemPreview = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.ScoreboardStatus = {
  SCOREBOARD_STATUS_UNDEFINED: 0,
  PARTIAL: 1,
  COMPLETED: 2
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.ScoreboardAccessType = {
  SCOREBOARD_ACCESS_TYPE_UNDEFINED: 0,
  SCOREBOARD_PUBLIC: 1,
  SCOREBOARD_ADMIN_ONLY: 2
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.ScoringStatus = {
  NOT_ATTEMPTED: 0,
  SOLVED: 1,
  PARTIALLY_SOLVED: 2,
  PROCESSING: 3
};

goog.object.extend(exports, proto.io.codedrills.proto.content);
